import React from 'react';

const HeroSection = () => (
  <section className="relative bg-gradient-to-br from-blue-50 to-purple-50 pt-32 pb-20 overflow-hidden">
    {/* Background decorative elements */}
    <div className="absolute inset-0 overflow-hidden">
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
    </div>

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 tracking-tight">
          Empower Learning with
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
            AI-Powered Virtual Teachers
          </span>
        </h1>
        <p className="mt-6 text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
          Personalized, engaging, and adaptive education for schools, businesses, and lifelong learners.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <button className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-lg font-semibold rounded-full hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200">
            Start Your Free Trial
          </button>
          <button className="px-8 py-4 bg-white text-gray-700 text-lg font-semibold rounded-full border-2 border-gray-200 hover:border-gray-300 hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200">
            Watch How it Works
          </button>
        </div>

        {/* Trust indicators */}
        <div className="mt-16 grid grid-cols-2 gap-8 md:grid-cols-4 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl font-bold text-blue-600">10K+</div>
            <div className="text-sm text-gray-600">Active Students</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-600">50+</div>
            <div className="text-sm text-gray-600">Expert Teachers</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-pink-600">15+</div>
            <div className="text-sm text-gray-600">Countries</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-indigo-600">4.9/5</div>
            <div className="text-sm text-gray-600">Parent Rating</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;